/**
 * FORMAT options for the email-export dialog. Kept in one place so the
 * dropdown labels, the <Select> options, and the blob-builders agree on
 * a single canonical list.
 */
export const FORMATS = [
  { value: 'csv',  label: 'CSV (.csv)',           ext: 'csv',  mime: 'text/csv' },
  { value: 'xlsx', label: 'Excel (.xlsx)',        ext: 'xlsx', mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  { value: 'pdf',  label: 'PDF (page snapshot)',  ext: 'pdf',  mime: 'application/pdf' },
];

export const STEEL_PILL_GRADIENT = 'linear-gradient(135deg, #64748B 0%, #0F172A 100%)';
